import { useEffect, useState } from 'react';
import axios from 'axios';
import { useClient } from 'ClientContext';

interface Location {
  city: string;
  state: string;
  country: string;
}

interface UseGetLocationsReturn {
  locations: Location[];
  loading: boolean;
  error: Error | null;
}

const SERVER_URL = process.env.REACT_APP_SERVER_URL || "";

export function useGetLocations(): UseGetLocationsReturn {
  const [locations, setLocations] = useState<Location[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const {internal_ID,actions,isLocationFilter} = useClient();

  useEffect(() => {
    if(!isLocationFilter){
      return;
    }
    const fetchLocations = async () => {
      setLoading(true);
      setError(null);

      try {

        const response = await axios.post(`${SERVER_URL}/api/controller`, {
            action: actions.fetchLocations,
            internal_ID,

        });
        const { items } = response.data;
        setLocations(items);
      } catch (err) {
        setError(err as Error);
      } finally {
        setLoading(false);
      }
    };

    fetchLocations();
  }, []);

  return { locations, loading, error };
}